import { create } from 'zustand';

interface SidebarState {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
  toggleSidebar: () => void;
}

export const useSidebarStore = create<SidebarState>((set) => ({
  isOpen: false, // Default to closed
  setOpen: (open) => set({ isOpen: open }),
  toggleSidebar: () => set((state) => ({ isOpen: !state.isOpen })),
}));
